/* eslint-disable @typescript-eslint/no-require-imports */
/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    locales: ['en', 'es'],
    defaultLocale: 'es',
    localeDetection: false
  },
  localePath:
    typeof window === 'undefined'
      ? require('path').resolve('./public/locales')
      : '/locales',
  // Pick up locale JSON edits in dev without restarting the server. Without
  // this, next-i18next caches translations after the first SSR pass; adding
  // a new key (or fixing a typo) requires a manual `yarn dev` restart, and
  // any visiting page throws on missing keys until then. Production builds
  // keep the cache for performance.
  reloadOnPrerender: process.env.NODE_ENV === 'development'
}
